import { Navigate, Outlet } from 'react-router-dom';
import GuestNavbar from '../guest-navbar';
import styles from './styles';
import cookiesManager from '../../utils/cookies';
import { AUTH_KEYS } from '../../utils/cookies/keys';

const GuestRoute = () => {
  const accessToken = cookiesManager.get(AUTH_KEYS.ACCESS_TOKEN);
  if (accessToken) {
    return <Navigate to = "/" replace />;
  }
  return (
    <div>
      <GuestNavbar />
      <main css={styles.mainContainer}>
        <Outlet />
      </main>
    </div>
  );
};

export default GuestRoute;
